export const DELAY_REASON_OPTIONS = [
  {
    label: "Carrier related",
    value: "carrier_related",
  },
  {
    label: "Customs related",
    value: "customs_related",
  },
  {
    label: "Holiday / weekend delivery",
    value: "holiday_weekend_delivery",
  },
  {
    label: "Holiday / weekend pickup",
    value: "holiday_weekend_pickup",
  },
  {
    label: "Shipper related / not ready to pickup",
    value: "shipper_related",
  },
  {
    label: "Transit delay",
    value: "transit_delay",
  },
  {
    label: "Warehousing related",
    value: "warehousing_related",
  },
  {
    label: "Weather related",
    value: "weather_related",
  },
];

export const OTHER_BUCKET = [
  {
    id: 1,
    isSyntheticOther: true,
    is_active: true,
    is_mandatory: false,
    is_mandatory_on_cancelation: false,
    bucket_name: "Other",
    bucket_type: "other",
    freight_modes: "",
    availability: 1,
    ordering_on_approved_invoice: null,
    shipper_locations: [],
  },
];
